import { defineComponent } from 'vue';
export default defineComponent({
    name: 'LogoutComponent',
    created() {
        this.$auth.signOut();
    },
});
